import React from 'react'
import { createRoot } from 'react-dom/client'
import { flushSync } from 'react-dom'
import { Subject } from 'rxjs'

const container = document.querySelector('#app') || document.body

export default (LayoutWrapper) => {
  const Render = new Subject()

  // flushSync, not a plain root.render(): the router fires the first page's
  // data through Render synchronously as part of mounting (see Router.js),
  // but createRoot normally defers the initial mount's effects - where
  // LayoutWrapperComponent subscribes to Render - to a later tick. Without
  // this, that first emission fires before anything has subscribed and is
  // lost forever, since Subject (correctly, for every later emission -
  // components elsewhere rely on late subscribers NOT replaying stale page
  // data) doesn't replay to late subscribers. flushSync forces the initial
  // mount's effects to run before this call returns, matching the old
  // ReactDOM.render behaviour, without changing Render's semantics.
  flushSync(() => {
    createRoot(container).render(
      <LayoutWrapper state={Render} />
    )
  })

  return function (components = {}, pageData = {}, layoutData = {}) {
    Render.next({ components, pageData, layoutData })
  }
}
